import {
  FC,
  createContext,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'
import usePopup, { PopupReturnTypeWithPayload } from 'hooks/usePopup'
import {
  generateResolutionLinkPopupWithPayload,
  resolutionLinkGeneratedPopupWithPayload,
  GenerateResolutionLinkPopupPayload,
  ResolutionLinkGeneratedPopupPayload
} from './constants'

type ContextProps = {
  generateResolutionLinkPopup: PopupReturnTypeWithPayload<GenerateResolutionLinkPopupPayload>
  resolutionLinkGeneratedPopup: PopupReturnTypeWithPayload<ResolutionLinkGeneratedPopupPayload>
}

const basePopup = (title: string) => ({
  title
})

const BankingSetupPopupContext = createContext<ContextProps>({
  generateResolutionLinkPopup: generateResolutionLinkPopupWithPayload,
  resolutionLinkGeneratedPopup: resolutionLinkGeneratedPopupWithPayload
})

const BankingSetupPopupProvider: FC<PropsWithChildren> = ({ children }) => {
  const generateResolutionLinkPopupProps =
    usePopup<GenerateResolutionLinkPopupPayload>(
      basePopup('Generate resolution link')
    )
  const resolutionLinkGeneratedPopupProps =
    usePopup<ResolutionLinkGeneratedPopupPayload>(basePopup('Link generated'))
  const context = useMemo(
    () => ({
      generateResolutionLinkPopup: generateResolutionLinkPopupProps,
      resolutionLinkGeneratedPopup: resolutionLinkGeneratedPopupProps
    }),
    [generateResolutionLinkPopupProps, resolutionLinkGeneratedPopupProps]
  )

  return (
    <BankingSetupPopupContext.Provider value={context}>
      {children}
    </BankingSetupPopupContext.Provider>
  )
}

export const useBankingSetupPopup = () => useContext(BankingSetupPopupContext)

export default BankingSetupPopupProvider
